import React from 'react';
import type {Position} from '@xyflow/react';
import { BaseEdge, getSmoothStepPath, EdgeLabelRenderer} from '@xyflow/react';
import type {NexusFlowEdgeData} from './nexusGraphTypes';

export const NexusFlowEdge: React.FC<{
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  sourcePosition: Position;
  targetPosition: Position;
  data?: NexusFlowEdgeData;
  markerEnd?: string;
  style?: React.CSSProperties;
}> = ({id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, markerEnd, style: externalStyle}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    borderRadius: 8,
  });

  const label = data?.dashed ? undefined : data?.edgeLabel;
  const muted = data?.muted;
  const dashed = data?.dashed;

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={dashed ? undefined : markerEnd}
        style={{
          stroke: dashed ? 'var(--mantine-color-gray-4)' : muted ? 'var(--mantine-color-gray-3)' : 'var(--mantine-color-gray-5)',
          strokeWidth: 1.5,
          strokeDasharray: dashed ? '6 4' : undefined,
          ...externalStyle,
        }}
      />
      {label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'none',
              background: 'var(--mantine-color-body, #fff)',
              padding: '2px 8px',
              borderRadius: 4,
              border: '1px solid var(--mantine-color-gray-3)',
              fontSize: 11,
              color: 'var(--mantine-color-dimmed)',
              whiteSpace: 'nowrap',
              opacity: muted ? 0.5 : 1,
            }}>
            {label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};
